import { axiosApi } from "../../../api/dbAxios";

export const fetchFavoriteList = async () => {
  try {
    const response = await axiosApi.get(`/favorite/`);

    return response.data;
  } catch (error) {
    console.error("Error fetching favorite list:", error);
    return [];
  }
};
